import * as R from 'ramda';
import queryString from 'query-string';
import WindowProvider from '../../common/window';
import SolanaDevWallet from './solanaDevWallet';
import validationService from '../../services/validation';
import authenticationService from '../../services/authentication';
import sip from '../../services/secureIdentityProvider';
// eslint-disable-next-line import/no-named-as-default
import { getSigner } from '../../services/signer';
import faceAuthentication from '../../services/faceAuthentication';
import documentCapture from '../../services/documentCapture';
import { isMockable } from '../../services/common/mockable';
import Log from '../../common/logging';

const setMockHeaders = (queryParams: queryString.ParsedQuery<string>): void => {
  const { testCase } = queryParams || {};
  const testCaseValue: string | null = R.is(String, testCase) ? (testCase as string) : null;
  if (!testCaseValue) {
    return;
  }

  if (isMockable(validationService)) {
    validationService.setMockMode(testCaseValue);
  }

  if (isMockable(authenticationService)) {
    authenticationService.setMockMode(testCaseValue);
  }

  if (isMockable(documentCapture)) {
    documentCapture.setMockMode(testCaseValue);
  }

  if (isMockable(sip)) {
    sip.setMockMode(testCaseValue);
  }

  if (isMockable(faceAuthentication)) {
    faceAuthentication.setMockMode(testCaseValue);
  }
};

const initializeDevWallet = (): void => {
  const isInIframe = WindowProvider.isInIframe();
  if (!isInIframe) {
    const maxRetries = 5;
    let walletAddress: string | null = null;

    const attemptToLoadWallet = (attempt: number) => {
      if (attempt < maxRetries) {
        const devWallet = SolanaDevWallet.load();
        walletAddress = devWallet.publicKey.toBase58();

        if (walletAddress) {
          const signer = getSigner('devWallet');
          signer.withWallet(devWallet);
        } else {
          Log.debug(`Attempt ${attempt + 1}: Wallet address is null, retrying...`);
          setTimeout(() => attemptToLoadWallet(attempt + 1), 1000);
        }
      } else {
        Log.debug('Failed to retrieve a valid wallet address after maximum attempts');
      }
    };

    attemptToLoadWallet(0);
  }
};

const initialiseDevMode = (queryParams: queryString.ParsedQuery<string>): void => {
  const isE2e =
    (process.env.REACT_APP_STAGE || 'unknown') === 'e2e' ||
    (process.env.REACT_APP_STAGE || 'unknown') === 'preprod_e2e';
  const isMock = (process.env.REACT_APP_STAGE || 'unknown') === 'mock';
  const isDev = (process.env.REACT_APP_STAGE || 'unknown') === 'dev';

  if (!isE2e && !isMock && !isDev) {
    return;
  }

  setMockHeaders(queryParams);
  initializeDevWallet();
};

export default initialiseDevMode;
